import { ILineItem } from '../../ILineItem';
import React from 'react';
import { useGetDisbursementsForSettlementItem } from '../../edit/useGetDisbursementsForSettlementItem';
import { DisbursementStatusPill } from './DisbursementStatusPill';

export interface IStatusColumnProps {
  fee?: ILineItem;
}

export const StatusColumn: React.FC<IStatusColumnProps> = ({ fee }) => {
  const disbursementsByFee = useGetDisbursementsForSettlementItem(fee?.disbursementIds);

  return (
    <div className={'flex flex-col space-y-1.5'}>
      {disbursementsByFee.map((item, index) => (
        <DisbursementStatusPill
          key={fee?.fees?.[index].statementFeeId ?? index}
          disbursements={item}
          isFeeDisplay
          hasQuickAdd
          feeId={fee?.id}
          fee={fee?.fees?.[index]}
          statementFeeId={fee?.fees ? fee.fees[index].statementFeeId : undefined}
        />
      ))}
    </div>
  );
};
